<template>
  <div class="col-6 col-sm-3 col-xl-2 p-0" :id="getId">
    <div class="card text-center p-0">
      <div class="card-header text-light bd-navbar d-flex justify-content-center p-2">
        <h5>
          <a class="text-light" :href="provider.homepage">{{provider.name}}</a>
        </h5>
        <div v-if="provider.icon" class="pl-2">
          <img class="i42Icon" :src="provider.icon">
        </div>
      </div>
      <content-static-provider-error v-if="hasError" v-on:reload="loadBitcoin"/>
      <div>
        <div class="card text-center" v-for="coin in Object.keys(bitcoinData.DISPLAY)" :key="coin">
          <div class="row no-gutters align-items-center">
            <div class="col-auto justify-content-center p-1">
              <img
                class="avatar avatar-icon"
                :src="getImgUrl(bitcoinData.DISPLAY[coin].EUR.IMAGEURL)"
              >
            </div>
            <div class="col col-md-8">
              <div class="card-body p-1">
                <p class="card-text">1 {{cryptoCurrencies[coin].name}}</p>
                <h4>{{bitcoinData.DISPLAY[coin].EUR.PRICE}}</h4>
              </div>
            </div>
          </div>
          <div class="row no-gutters align-items-center">
            <div class="col-6">
              <p class="card-text text-muted">€ 24h</p>
            </div>
            <div class="col-6">
              <p class="card-text text-muted">% 24h</p>
            </div>
          </div>
          <div
            class="row no-gutters align-items-center"
            v-bind:class="{ 'text-danger': bitcoinData.RAW[coin].EUR.CHANGE24HOUR < 0, 'text-success': bitcoinData.RAW[coin].EUR.CHANGE24HOUR > 0 }"
          >
            <div class="col-6">
              <p class="card-text">
                <i
                  v-if="bitcoinData.RAW[coin].EUR.CHANGE24HOUR < 0"
                  class="fas fa-arrow-circle-down"
                ></i>
                <i v-if="bitcoinData.RAW[coin].EUR.CHANGE24HOUR > 0" class="fas fa-arrow-circle-up"></i>
                {{bitcoinData.DISPLAY[coin].EUR.CHANGE24HOUR}}
              </p>
            </div>
            <div class="col-6">
              <p class="card-text">{{bitcoinData.DISPLAY[coin].EUR.CHANGEPCT24HOUR}} %</p>
            </div>
          </div>
        </div>
      </div>
      <content-static-provider-wait v-if="isLoading"/>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ContentStaticProviderWait from "@/components/ContentStaticProviderWait.vue";
import ContentStaticProviderError from "@/components/ContentStaticProviderError.vue";

export default {
  name: "RenderBitcoin",
  components: {
    ContentStaticProviderWait,
    ContentStaticProviderError
  },
  data: function() {
    return {
      isLoading: false,
      hasError: false,
      cryptoCurrencies: {
        BTC: { id: "BTC", name: "Bitcoin" },
        ETH: { id: "ETH", name: "Ethereum" },
        XRP: { id: "XRP", name: "XRP" },
        BCH: { id: "BCH", name: "Bitcoin Cash" },
        EOS: { id: "EOS", name: "EOS" },
        LTC: { id: "LTC", name: "Litecoin" },
        XLM: { id: "XLM", name: "Stellar" },
        ADA: { id: "ADA", name: "Cardano" },
        USDT: { id: "USDT", name: "Tether" },
        XMO: { id: "XMO", name: "Monero" },
        MIOTA: { id: "MIOTA", name: "IOTA" }
      },
      bitcoinData: { DISPLAY: {} }
    };
  },
  props: {
    provider: {}
  },
  computed: {
    getId: function() {
      return "p" + this.provider.id;
    }
  },
  methods: {
    getImgUrl: function(imgUri) {
      return "https://www.cryptocompare.com" + imgUri;
    },
    loadBitcoin: function() {
      this.isLoading = true;

      this.hasError = false;

      let currencies = Object.keys(this.cryptoCurrencies).join(",");

      //let baseUrl = "https://www.cryptocompare.com"

      //let requestURL = "https://api.coindesk.com/v1/bpi/currentprice.json";
      // let requestURL =
      //   "https://min-api.cryptocompare.com/data/pricemulti?fsyms=BTC,ETH,LTC,ADA,XMO,MIOTA,XVG,XLM&tsyms=EUR";
      //https://min-api.cryptocompare.com/data/pricemultifull?fsyms=BTC&tsyms=EUR
      let requestURL =
        "https://min-api.cryptocompare.com/data/pricemultifull?fsyms=" +
        currencies +
        "&tsyms=EUR";

      axios
        .get(requestURL, {
          responseType: "json"
        })
        .then(response => {
          if (response == "") {
            this.hasError = true;
          } else {
            this.bitcoinData = response.data;
          }
        })
        .catch(error => {
          console.log(error);
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  mounted() {
    this.loadBitcoin();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bd-navbar {
  background-color: #563d7c;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05),
    inset 0 -1px 0 rgba(0, 0, 0, 0.1);
}
.i42Icon {
  max-height: 20px;
  width: auto;
}

.avatar {
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 3rem;
  font-size: 1rem;
}

.avatar-img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
</style>
